/**
 * Recently visited routes (Phase 2.8).
 *
 * Kept in localStorage and surfaced in the command palette when the query is empty —
 * not as a permanent sidebar list (per the audit / brief §12). The palette resolves
 * routes to known destinations and permission-filters them, so a recent entry the
 * user can no longer reach simply does not appear.
 */
const KEY = 'connaro.recent';
const MAX = 8;

export function readRecent(): string[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(value) ? (value as string[]) : [];
  } catch {
    return [];
  }
}

export function recordRecent(route: string): void {
  const next = [route, ...readRecent().filter((r) => r !== route)].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Storage unavailable; recent history just won't persist.
  }
}
